import { cacheAddChatRoomNote, cacheDeleteChatRoomNote } from '@/graphql/cache/cache-mutations';
import { ChatRoomNoteActionEnum, useChatRoomNoteSubscription } from '@/types/generated/graphql';

// Note changes from any member of any room this member is in, their own included. An update needs no
// handling: Apollo has already merged the payload into the normalised ChatRoomNote. The prepend
// de-dupes by id, so the author's own create — already added by the mutation — is not listed twice.
export function useRoomNotesSubscription() {
  useChatRoomNoteSubscription({
    onData: ({ data }) => {
      const event = data.data?.chatRoomNote;
      if (!event?.note?.id) return;

      if (event.action === ChatRoomNoteActionEnum.created) cacheAddChatRoomNote(event.roomId, event.note);
      if (event.action === ChatRoomNoteActionEnum.deleted) cacheDeleteChatRoomNote(event.note.id);
    },
  });
}
